const steps = [{
  title: 'Apply to the program',
  description: 'Submit a quick application\nto our team.'
}, {
  title: 'Share Uppbeat',
  description: 'Your audience gets 20% off\nwith your unique link.'
}, {
  title: 'Earn commission',
  description: 'They subscribe, you\nearn 30%.'
}];
const HowItWorks = () => <section className="special-page-container relative z-[1] scroll-mt-20 py-5 md:py-10" id="how-it-works" data-sentry-component="HowItWorks" data-sentry-source-file="HowItWorks.tsx">
    <h2 className="mb-1 text-pretty font-semibold text-2xl 2xl:text-3xl">
      How it works
    </h2>
    <p className="mb-8 text-pretty font-sans text-base text-gray-700 dark:text-gray-200">
      Simple steps to start earning with Uppbeat
    </p>
    <div className="relative md:mx-auto md:max-w-4xl">
      <div aria-hidden="true" className="absolute inset-x-1/6 top-8 hidden h-px bg-pink-100 md:block dark:bg-pink-900" />
      <ol className="flex list-none flex-col gap-8 md:flex-row">
        {steps.map((step, index) => <li className="relative flex gap-4 after:absolute after:top-16 after:-bottom-8 after:left-8 after:w-px after:bg-pink-100 last:after:hidden md:flex-1 md:flex-col md:items-center md:gap-5 md:text-center md:after:hidden dark:after:bg-pink-900" key={step.title}>
            <div className="relative z-[1] flex size-16 shrink-0 items-center justify-center rounded-full border-1 border-pink-100 border-solid bg-pink-50 dark:border-pink-900 dark:bg-pink-950">
              <span aria-hidden="true" className="font-bold font-heading text-4xl text-pink-600 leading-none dark:text-pink-400">
                {index + 1}
              </span>
            </div>
            <div className="self-center md:w-63 md:max-w-full md:self-auto">
              <h3 className="mb-0.5 font-sans font-semibold text-gray-950 text-lg dark:text-white">
                {step.title}
              </h3>
              <p className="text-pretty font-sans text-gray-700 text-sm md:whitespace-pre-line dark:text-gray-200">
                {step.description}
              </p>
            </div>
          </li>)}
      </ol>
    </div>
  </section>;
export default HowItWorks;